<template>
  <loginLayout>
    <div class="box">
      <div>
        <a href="/index">
          <img class="login-name" src="../../assets/image/logo.png" alt=""/>
        </a>
      </div>
      <div class="link-warp">
        <div
          :class="['link-item', { active: item.id === step }]"
          v-for="item in navList"
          :key="item.value"
          @click="onClick(item.id)">
          {{ item.label }}
        </div>
      </div>
      <div class="login-box">
        <div class="login-input">
          <div class="login-input-prefix">用户名：</div>
          <Input class="input-box" placeholder="用户ID/手机号码/账户邮箱" clearable v-model="form.name"></Input>
        </div>
        <div class="login-input mt-24" v-if="step === 0">
          <div class="login-input-prefix">密码：</div>
          <Input class="input-box" type="password" placeholder="请输入登录密码" clearable v-model="form.password"></Input>
        </div>
        <div class="flex-content-between mt-24" v-if="step === 1">
          <div class="login-input" style="width: 250px;">
            <div class="login-input-prefix">验证码：</div>
            <Input class="input-box" placeholder="请输入验证码" clearable v-model="form.code" @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"></Input>
          </div>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px"
          >{{text1}}</Button>
        </div>
        <div class="flex-content-between" style="margin-top: 40px">
          <Checkbox class="bj-color-F85A36" v-model="single"> 记住我</Checkbox>
          <router-link class="f-link" to="/forgot">忘记密码？</router-link>
        </div>
        <Button class="login-btn" type="primary" shape="circle" long :loading="loading" @click="submit">登录</Button>
        <div class="bj-rows" style="margin-top: 24px;">
          <div>还没有账号</div>
          <router-link class="link" to="/sige">立即注册</router-link>
        </div>
      </div>
      <Modal
          v-model="verifyshow"
          title="验证码"
          @on-ok="getCodeEvent"
          @on-cancel="verifyshow = false">
        <div class="verify-info">
          <div class="verify-code">
            <span class="verify-label">验证码</span>
            <div class="verify-block">
              <img id="verificationCode" class="verify-img" @click="refreshCode">
            </div>
          </div>
          <input
              v-model="codeValue"
              class="verify-input"
              placeholder="请输入验证码"
          >
        </div>
      </Modal>
    </div>
  </loginLayout>
</template>

<script>
import loginLayout from "./components/loginLayout.vue";
import { mapMutations, mapState } from "vuex";
import { getEncrypt } from "utils/encrypt";
import { getLoginCode, login, getAmountInfo, getMemberInfo } from "api/user.js";
import { Base64 } from "js-base64";
import { API_BASE_URL } from "@/utils/config";
export default {
  name: "login",
  components: {
    loginLayout,
  },
  data() {
    return {
      step: 0, // 0 密码登录 1 短信登录
      single: false,
      form: {
        name: "",
        password: "",
        code: "",
      },
      loading: false,
      navList: [
        {
          id: 0,
          active: true,
          value: "/my/template",
          label: "密码登录",
        },
        {
          id: 1,
          active: false,
          value: "/my/template/add",
          label: "短信/邮箱登录",
        },
      ],
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  watch: {
    step: {
      immediate: true,
      handler(val) {
        if (val === 0) {
          const rememberMe = localStorage.getItem("U_RememberMe");
          if (rememberMe && rememberMe === "true") {
            this.form.name = localStorage.getItem("U_ID");
            this.form.password = Base64.decode(
              localStorage.getItem("U_Secret")
            );
          }
          this.single = rememberMe === "true";
        }
      },
    },
  },
  computed: {
    ...mapState(["prevRouter"]),
    text() {
      return this.step === 0 ? "短信/邮箱登录" : "密码登录";
    },
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}bjweb/sms/login/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    ...mapMutations(["MUT_TOKEN_INFO", "MUT_AMOUNT", "MUT_USER_INFO"]),
    onClick(value) {
      this.step = value;
    },
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码或邮箱！");
        this.$refs.smsBtn.reset();
        return;
      }
      getLoginCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.codeDisabled = true
            this.text1 = `${i--}秒后再获取`;
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text1 = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text1 = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入用户ID/手机号码/账户邮箱！");
        return false;
      }
      if (this.step === 1) {
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
      }else{
        if (!this.form.password) {
          this.$Message.warning("请输入密码！");
          return false;
        }
      }

      let params = {
        zh: this.form.name,
        type: this.step,
        ly: 0,
      };

      this.step === 0
        ? (params["mm"] = getEncrypt(this.form.password))
        : (params["yzm"] = this.form.code);
      this.loading = true;
      login(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.result) {
            if (this.single) {
              localStorage.setItem("U_ID", this.form.name);
              localStorage.setItem(
                "U_Secret",
                Base64.encode(this.form.password)
              );
              localStorage.setItem("U_RememberMe", this.single);
            }
            this.MUT_TOKEN_INFO(res.data);
            Promise.all([getAmountInfo(), getMemberInfo()]).then((res2) => {
              const { code, data, result } = res2[0];
              const { code: code2, data: data2, result: result2 } = res2[1];
              if (code === 200 && result) {
                this.MUT_AMOUNT(data);
              }
              if (code2 === 200 && result2) {
                this.MUT_USER_INFO(data2);
              }
              this.$Message.success("登录成功!");
              this.$router.replace(this.prevRouter);
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
  .box{
    padding: 60px 50px;
    .login-name{
      height: 70px;
    }
    .link-warp {
      margin-top: 20%;
      position: relative;
      .link-item {
        display: inline-block;
        height: 60px;
        line-height: 60px;
        margin: 0 30px;
        color: #333;
        font-size: 24px;
        font-weight: bold;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
        &:first-child{
          margin-left: 0;
        }
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          width: 0;
          height: 3px;
          background-color: #F85A36;
          transition: all 0.3s;
        }
      }
      .link-item.active {
        color: #F85A36;
        &::before{
          width: 100%;
        }
      }
    }
  }
  .login-box{
    margin-top: 20%;
    .login-input{
      border: 1px solid #dcdee2;
      border-radius: 60px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 28px;
      .login-input-prefix{
        width: 100px;
      }
      .input-box{
        ::v-deep .ivu-input{
          border: none;
          &:focus{
            box-shadow: none
          }
        }
      }
    }
  }
  .mt-24{
    margin-top: 24px;
  }

  ::v-deep .login-btn {
    margin-top: 40px;
    height: 60px;
    font-size: 14px;
    font-weight: 400;
    background-color: #F85A36;
    border-color: #F85A36;
    &:hover{
      border-color: #F85A36;
    }
    &:focus{
      box-shadow: none;
    }
  }
  .link{
    margin-left: 20px;
    color: #F85A36;
  }
  .f-link {
    color: #F85A36;
  }
  .verify-info {
    padding: 15px 30px;
  }
  .verify-label {
    background-color: #f7fafb;
    width: 80px;
    font-size: 14px;
    padding: 0 15px;
    line-height: 58px;
    text-align: center;
  }
  .verify-code {
    border: 1px solid #e9eaec;
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .verify-input {
    display: block;
    width: 100%;
    border: 1px solid #e9eaec;
    border-radius: 6px;
    outline: none;
    padding: 0 20px;
    line-height: 40px;
    box-sizing: border-box;
  }
  .verify-block {
    display: flex;
    justify-content: center;
    align-items: stretch;
    margin-left: 10px;
  }
  ::v-deep .ivu-modal-content {
    background-color: #fff!important;
  }
  .sms-btn ::v-deep {
    .ivu-btn {
      width: 100%;
      height: 100%;
      background-color: #F85A36;
      color: #fff;
      &:hover{
        border-color: #F85A36;
      }
    }
  }
</style>
